import React from 'react';
import PerfilParte from '../Utils/PerfilParte';


const ClienteContent = ({ venda, setVenda }) => {
  const handleDataChange = (e) => {
    const novaData = e.target.value;
    setVenda((prevVenda) => ({
      ...prevVenda,
      data: novaData,
    }));
  };

  const handleObservacoesChange = (e) => {
    const novasObservacoes = e.target.value;
    setVenda((prevVenda) => ({
      ...prevVenda,
      observacoes: novasObservacoes,
    }));
  };

  return (
    <div>
      <PerfilParte cliente={venda?.cliente}/>
      <div className="row mb-2">
        <div className="col"></div>
        <div className="col-auto">
          <input
            type="date"
            className="form-control text-end"
            placeholder="Data da compra"
            value={venda?.data}
            onChange={handleDataChange}
          />
        </div>
        <div className="col-12">
          <textarea
            className="form-control observacoes mb-3 mt-2"
            placeholder="Observações"
            value={venda?.observacoes || ''}
            onChange={handleObservacoesChange}
          />
        </div>
      </div>
    </div>
  );
};

export default ClienteContent;